import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import TextField from 'material-ui/TextField';
import DialogModal from '../../common/DialogModal';
import Button from '../../Parts/Button';
import IconButton from 'material-ui/IconButton';
import { DialogTitle } from 'material-ui/Dialog';
import Toolbar from 'material-ui/Toolbar';

const { Set } = require("immutable");

const styles = () => ({
  paper: {
    maxHeight: 'unset',
    background: "#F4F6F9",
    width: '600px',
  },

  guttersContainer: {
    width: '100%',
    zIndex: 2,
  },

  gutters: {
    background: "#FFFFFF",
    fontSize: "15px",
    fontWeight: 700,
    boxShadow: '0px 1px 0px #00000029',
    width: '100%',
    boxSizing: 'border-box',
    position: 'sticky',
    top: 0,
    zIndex: 1,
    padding: '0 25px'
  },

  contentContainer: {
    margin: 0,
    padding: 0,
  },

  container: {
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '25px',
  },

  backBtn: {
    margin: 0,
    height: "60px",
    width: "60px",
    minWidth: "unset",
    fontSize: 13,
  },

  input: {
    boxSizing: 'border-box',
  },

  arrowLeft: {
    display: 'inline-block',
    verticalAlign: 'super',
    color: '#000000',
    position: 'relative',
    width: '11.5px',
    height: '2px',
    background: 'currentColor',
    margin: '0 10px 0 3px',

    '&::before': {
      content: '""',
      width: '10px',
      height: '10px',
      border: ' 2px solid currentColor',
      borderRight: '0',
      borderBottom: '0',
      transform: 'rotate(-45deg)',
      transformOrigin: 'top left',
      position: 'absolute',
      top: '50%',
      left: '-3px',
      boxSizing: 'border-box',
    },
  },
});

class CreateListDialog extends React.Component {
  state = {
    tags: Set(),
    tag: "",
  };

  handleClose = () => {
    this.props.toggleDialog();
    this.props.toggleEditTagsDialog();
  };

  handleChange = property => e => {
    this.setState({
      [property]: e.target.value
    });
  };

  handleSave = () => {
    this.setState({
      tags: this.state.tags.add(this.state.tag),
    }, () => {
      // If parent provided a saveTagsWithQuery (accepts tags, overrideQuery), use it so caller can supply relocation_personnel_ids
      if (typeof this.props.saveTagsWithQuery === 'function') {
        this.props.saveTagsWithQuery(this.state.tags.toArray(), this.props.overrideQuery);
      } else {
        this.props.saveTags(this.state.tags.toArray());
      }
      this.props.toggleDialog();
    });
  };

  render() {
    const { classes, toggleDialog, isOpen, isUpdatingTags } = this.props;

    return (
      <DialogModal
        open={isOpen}
        onClose={toggleDialog}
        aria-labelledby="pop-up-window"
        maxWidth={false}
        classes={{
          paper: classes.paper,
          contentContainer: classes.contentContainer,
          backButton: classes.backBtn
        }}
      >

        <div ref={this.setTitleRef} className={classes.guttersContainer}>
          <Toolbar classes={{ gutters: classes.gutters }}>
            <DialogTitle className={classes.dialogTitle} style={{ padding: 0 }} disableTypography>
              <IconButton
                color="default"
                className={classes.arrowLeft}
                onClick={this.handleClose}
              >
              </IconButton>
              新しいリストを作成
            </DialogTitle>
          </Toolbar>
        </div>

        <div className={classes.container}>
          <TextField
            id="tag"
            value={this.state.tag}
            InputProps={{
              disableUnderline: true,
            }}
            InputLabelProps={{ shrink: true, }}
            placeholder="新しく作成するリスト名を入力してください"
            onChange={this.handleChange("tag")}
            className={classes.input}
            fullWidth
          />
          <Button
            text="作成"
            handleClickButton={this.handleSave}
            disabled={!this.state.tag}
            loading={isUpdatingTags}
            style={{ marginTop: '15px', width: '200px' }}
          />
        </div>
      </DialogModal>
    );
  }
}

CreateListDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  isUpdatingTags: PropTypes.bool,
  saveTags: PropTypes.func.isRequired,
  saveTagsWithQuery: PropTypes.func,
  overrideQuery: PropTypes.object,
  toggleEditTagsDialog: PropTypes.func.isRequired,
};

export default withStyles(styles)(CreateListDialog);



// WEBPACK FOOTER //
// ./src/components/AddressBook/dialogs/CreateListDialog.jsx